module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyLotion@3x_179fa7.png";